import baseCreate from "./component-library446.mjs";
import getPrototype from "./component-library403.mjs";
import isPrototype from "./component-library447.mjs";
function initCloneObject(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
export {
  initCloneObject as default
};
